import { useEffect, useRef } from 'react';

export const useCarousel = (autoSlideInSec: number, isAutoSlide: boolean) => {
  const carouselInnerRef = useRef<HTMLDivElement>(null);
  const carouselSlideRef = useRef<HTMLDivElement>(null);
  const carouselNavRef = useRef<HTMLDivElement>(null);
  const intervalRef: any = useRef();
  const AUTO_SLIDE_IN_SEC = autoSlideInSec * 1000;
  const pauseSlider = () => {
    if (typeof clearInterval === 'function') clearInterval(intervalRef.current);
  };
  useEffect((): any => {
    let flag = true;
    if (flag && isAutoSlide && AUTO_SLIDE_IN_SEC > 0) {
      if (typeof clearInterval === 'function') clearInterval(intervalRef.current);
      startCarouselInterval();
      // carouselSlideRef.current?.addEventListener('mouseenter', pauseSlider);
      // carouselSlideRef.current?.addEventListener('mouseleave', startCarouselInterval);
    }
    return () => {
      flag = false;
      if (isAutoSlide && typeof clearInterval === 'function') clearInterval(intervalRef.current);
    };
  }, [AUTO_SLIDE_IN_SEC, isAutoSlide]);

  const startCarouselInterval = () => {
    if (typeof clearInterval === 'function') clearInterval(intervalRef.current);
    intervalRef.current =
      typeof setInterval === 'function'
        ? setInterval(() => runOnInterval(), AUTO_SLIDE_IN_SEC)
        : undefined;
  };
  const clearCarouselTimer = () => {
    if (isAutoSlide) {
      if (typeof clearInterval === 'function') clearInterval(intervalRef.current);
      startCarouselInterval();
    }
  };

  const runOnInterval = () => {
    //slides
    const initSlide: any =
      carouselInnerRef.current?.querySelector('.carousel-inner')?.firstElementChild;
    const activeSlide: any = carouselInnerRef.current?.querySelector('.carousel-item.active');
    const nextSlideToBeActive: any = activeSlide?.nextSibling;
    //indicators
    const initBtn: any =
      carouselNavRef.current?.querySelector('.nav-indicators')?.firstElementChild;
    const activeBtn: any = carouselNavRef.current?.querySelector('.carousel-indicators-btn.active');
    const nextBtnToBeActive: any = activeBtn?.nextSibling;
    //removing active class from slide and button
    activeSlide?.classList.remove('active');
    activeBtn?.setAttribute('aria-selected', false);
    activeBtn?.classList.remove('active');

    if (nextSlideToBeActive === null || nextSlideToBeActive === undefined) {
      initSlide?.classList.add('active');
      initBtn?.classList.add('active');
      initBtn?.setAttribute('aria-selected', true);
    } else {
      nextSlideToBeActive?.classList.add('active');
      nextBtnToBeActive?.classList.add('active');
      nextBtnToBeActive?.setAttribute('aria-selected', true);
    }
  };

  const navigateCarousel = (controlVariant: string, index?: number) => {
    const activeSlide: any = carouselInnerRef.current?.querySelector('.carousel-item.active');
    const activeBtn: any = carouselNavRef.current?.querySelector('.carousel-indicators-btn.active');

    if (controlVariant === 'right') {
      runOnInterval();
    } else if (controlVariant === 'left') {
      const lastSlide: any =
        carouselInnerRef.current?.querySelector('.carousel-inner')?.lastElementChild;
      const previousSlideToBeActive: any = activeSlide?.previousSibling;

      const lastBtn: any =
        carouselNavRef.current?.querySelector('.nav-indicators')?.lastElementChild;
      const previousBtnToBeActive: any = activeBtn?.previousSibling;
      activeSlide?.classList.remove('active');
      activeBtn?.classList.remove('active');
      activeBtn?.setAttribute('aria-selected', false);
      if (previousSlideToBeActive === null || previousSlideToBeActive === undefined) {
        lastSlide?.classList.add('active');
        lastBtn?.classList.add('active');
        lastBtn?.setAttribute('aria-selected', true);
      } else {
        if (lastBtn) lastBtn?.setAttribute('aria-selected', false);
        previousSlideToBeActive?.classList.add('active');
        previousBtnToBeActive?.classList.add('active');
        previousBtnToBeActive?.setAttribute('aria-selected', true);
      }
    } else if (index) {
      const slideToBeActive: any = carouselInnerRef.current?.querySelector(
        `.carousel-item:nth-of-type(${index})`,
      );
      const btnToBeActive: any = carouselNavRef.current?.querySelector(
        `.carousel-indicators-btn:nth-of-type(${index})`,
      );
      activeSlide?.classList.remove('active');
      activeBtn?.classList.remove('active');
      activeBtn?.setAttribute('aria-selected', false);
      slideToBeActive?.classList.add('active');
      btnToBeActive?.classList.add('active');
      btnToBeActive?.setAttribute('aria-selected', true);
    }
  };

  return {
    carouselInnerRef,
    carouselSlideRef,
    carouselNavRef,
    clearCarouselTimer,
    runOnInterval,
    navigateCarousel,
    pauseSlider,
    startCarouselInterval,
  };
};
